import React, { useState } from 'react'
import * as R from 'ramda'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import {
  Typography,
  IconButton,
  Icon,
  CircularProgress,
} from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import SecondaryButton from 'app/components/buttons/SecondaryButton'
import { FormattedMessage, useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  creditCard: {
    width: '75px',
  },
  cardHeight: {
    height: '90%',
  },
}))

export function PlanBillingPaypalCard(props) {
  const {
    email,
    className,
    onClick = () => {},
    onDelete,
    isDefault,
    paymentMethod,
  } = props

  const reduxDispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const { formatMessage } = useIntl()
  const handleLoadingState = (fn) => async (data) => {
    setIsLoading(true)
    try {
      await fn(data)
    } catch (error) {
      reduxDispatch(MessageAlert.showNetworkError(formatMessage)(error))
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteWithHandleLoadingState = handleLoadingState(onDelete)
  const handleSetDefaultWithHandleLoadingState = handleLoadingState(onClick)

  const classes = useStyles()
  return (
    <div
      className={clsx(
        'flex items-center relative',
        className,
        classes.cardHeight,
      )}
    >
      <img
        src={Assets.paymentMethodLogo.PayPalAccount}
        alt="logo-card"
        width={200}
      />
      <div className="flex-col space-y-5 m-10 w-1/2 md:w-full break-words">
        <Typography>{email}</Typography>
        <Typography variant="caption">
          <FormattedMessage id="planAndBilling.paymentMethod.card.paypal" />
        </Typography>
      </div>
      {onDelete && (
        <CardIcon
          isDefault={isDefault}
          isLoading={isLoading}
          onSetDefault={() => {
            handleSetDefaultWithHandleLoadingState(
              R.prop('token', paymentMethod),
            )
          }}
          onDelete={(e) => {
            e.stopPropagation()
            handleDeleteWithHandleLoadingState(R.prop('token', paymentMethod))
          }}
        />
      )}
    </div>
  )
}

const CardIcon = ({ isDefault, onSetDefault, isLoading, onDelete }) => {
  const classes = useStyles()
  if (isDefault) {
    if (isLoading) {
      return <CircularProgress className="self-center m-12 ml-auto w-24 h-24" />
    }
    return (
      <Typography className="italic ml-auto ltr:mr-24 rtl:ml-24 font-bold">
        <FormattedMessage id="planAndBilling.paymentMethod.card.defaultCard" />
      </Typography>
    )
  }

  return isLoading ? (
    <CircularProgress className="self-center m-12  ml-auto  w-24 h-24" />
  ) : (
    <div className="ml-auto">
      <SecondaryButton
        className="normal-case text-blue-primary"
        labelId="planAndBilling.paymentMethod.card.setAsDefaultCard"
        onClick={onSetDefault}
      />
      <IconButton
        key="close"
        aria-label="Close"
        className={clsx(classes.closeIcon)}
        onClick={onDelete}
      >
        <Icon>delete_outline</Icon>
      </IconButton>
    </div>
  )
}
